export const toggleMenu = () => {
  var element = document.getElementById("sidebar-menu");
  element.classList.toggle("open");
};

export const toggleMenuNetwork = () => {
  var element = document.getElementById(
    "sidebar-menu __custom_scroller__properties"
  );
  element.classList.toggle("open");
};

